/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Paper, Button, Modal } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import ReactPlayer from 'react-player';

import './scss/single-video.scss';
import Color from '@tool/color';
import { CloseIcon } from '@styled/icon';

interface IProps {
  isOpen:boolean
  close:()=>void
  url:string
  videoList:any
}
interface IState {}

const DButton = styled(Button)(() => ({}));

const DModal = styled(Modal)(() => ({
  zIndex: 5555555,
}));

const MultiVideo = (props: IProps, state: IState) => {
  const [curVideo, setcurVideo] = useState('');
  const { isOpen, close, url, videoList } = props;
  const [playing, setplaying] = useState(true);
  const changeUrl = (res:any) => {
    setcurVideo(res.src);
    setplaying(true);
  };

  useEffect(() => {
    setcurVideo(url);
    return () => {};
  }, [url]);

  return (
    <DModal open={isOpen}>
      <section className="video-1155">
        <section className="video-1166">
          <ReactPlayer playing={playing} controls={true}
            width={800} height={500} url={curVideo} loop={true} />
          <p className="close-111" aria-hidden="true"
            onClick={close} >
            <CloseIcon width={30} height={30} color={Color.fff} />
          </p>
          <section className='small-img'>
            {
              videoList?.map((res:any) => {
                return <section className='item' key={res.title} onClick={() => {changeUrl(res);}}>
                  <img src={res.page} alt="" />
                  <p><span>{res.name}</span>{res.title}</p>
                </section>;
              })
            }
          </section>
        </section>
      </section>
    </DModal>
  );
};

export default observer(MultiVideo);
